import { Injectable } from '@angular/core';
import { WorkshopDefect } from '../models/workshop-defect.model';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class WorkshopDefectService {

  private _endpoint: string = environment.api.endpoint;

  constructor(private httpClient: HttpClient) { }

  getOpenDefects(): Observable<WorkshopDefect[]> {
    return this.httpClient.get(this._endpoint + 'workshop-defect?filter=status||ne||complete&sort=createdAt,DESC')
    .pipe(map((data) => {
      return <WorkshopDefect[]>data;
    }));
  }

  getWorkshopDefectById(id: number): Observable<WorkshopDefect> {

    if(id <= 0 || id === null || id === undefined) {
      throw new Error('WorkshopDefectService: Id must be a valid number');
    }

    return this.httpClient.get(this._endpoint + 'workshop-defect/' + id).pipe(map((value: any) => {
      return <WorkshopDefect>value;
    }));
  }

  createWorkshopDefect(defect: WorkshopDefect): Observable<WorkshopDefect> {

    if(!defect) {
      throw new Error('workshop defect service: you must supply a workshop defect object for saving');
    }

    delete defect.createdAt;
    delete defect.updatedAt;

    if(defect.id > 0) {
      throw new Error('workshop defect service: Cannot create an existing object');
    }

    delete defect.id;
    return this.httpClient.post(this._endpoint + 'workshop-defect',
    JSON.stringify(defect),
    {headers: {'Content-Type': 'application/json'}}).pipe(map((data) => {
      return <WorkshopDefect>data;
    }));
  }

  updateWorkshopDefect(defect: WorkshopDefect): Observable<WorkshopDefect> {

    if(!defect) {
      throw new Error('workshop defect service: you must supply a workshop defect object for saving');
    }

    delete defect.createdAt;
    delete defect.updatedAt;

    if(!defect.id || defect.id === -1) {
      throw new Error('workshop defect service: Cannot update a record without id');
    }

    return this.httpClient.put(this._endpoint + 'workshop-defect/' + defect.id,
    JSON.stringify(defect),
    {headers: {'Content-Type': 'application/json'}}).pipe(map((data) => {
      return <WorkshopDefect>data;
    }));
  }
}
